{
  "nav": {
    "home": "Home",
    "pick": "Pick",
    "leaderboard": "Classifica",
    "profile": "Profilo",
    "leagues": "Leghe",
    "active_league": "Lega Attiva"
  },
  "common": {
    "error_data": "Errore nel caricamento dati.",
    "stage": "Tappa",
    "go": "VAI",
    "back": "← Indietro",
    "one_day_race": "One Day Race",
    "tomorrow": "Domani",
    "in_days_one": "Domani",
    "in_days_many": "Tra {{count}} giorni",
    "in_days_other": "Tra {{count}} giorni",
    "at_hours": "Ore {{hours}}",
    "loading": "Caricamento...",
    "confirm": "CONFERMA",
    "logout": "ESCI",
    "in_days": "Tra {{count}} giorni",
    "error_generic": "Si è verificato un errore.",
    "optional": "opzionale",
    "tu": "TU",
    "error_title": "Errore",
    "send": "Invia",
    "retry": "Riprova",
    "load_error_title": "Non riesco a caricare i dati",
    "load_error_sub": "Controlla la connessione e riprova.",
    "stale_data": "Dati non aggiornati: mostro quelli salvati."
  },
  "home": {
    "participants": "partecipanti",
    "section_results": "Ultimi risultati",
    "section_upcoming": "Prossime gare",
    "social": "Seguici sui social",
    "onboarding_next": "Avanti →",
    "onboarding_start": "Inizia a giocare →",
    "onboarding_rules": "Leggi il regolamento",
    "section_picks": "Pick da fare",
    "no_races": "Nessuna gara da pickare al momento",
    "other_picks_one": "un'altra pick da fare →",
    "other_picks_many": "altre {{count}} pick da fare →",
    "other_picks_other": "altre {{count}} pick da fare →",
    "stage_results": "Classifica",
    "tab_stage": "TAPPA",
    "tab_gc": "GENERALE",
    "no_data": "Nessun dato disponibile",
    "onboarding_step1_title": "Benvenuto in Virtua Cycling!",
    "onboarding_step1_body": "Il fantasy game del ciclismo professionistico.",
    "onboarding_step2_title": "Come funziona",
    "onboarding_item1": "Scegli i tuoi corridori — Prima di ogni tappa, picka i corridori su cui punti. Hai tempo fino alla partenza.",
    "onboarding_item2": "Guadagna punti — I tuoi corridori fanno punti in base al piazzamento reale nella tappa e nella classifica generale.",
    "onboarding_item3": "Crea la tua lega — Confrontati con gli altri partecipanti tappa per tappa, e scala la classifica generale.",
    "onboarding_step3_title": "Sei pronto!",
    "onboarding_step3_body": "Sei nella Virtua Cycling League, la lega generale dove giocano tutti. Leggi il regolamento completo per non perderti nulla.",
    "kofi_cta": "Ti piace l'app? Offrici una birra!",
    "jersey_gc": "Maglia leader GC",
    "jersey_pt": "Maglia a punti",
    "jersey_gm": "Maglia GPM",
    "greeting": "Ciao, {{name}}",
    "status_ready": "Scelte confermate per la prossima tappa",
    "status_todo": "Non hai ancora fatto le tue scelte",
    "retry": "Riprova"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Pick già effettuate — puoi ancora cambiarle",
    "no_pick_stage": "Nessuna pick trovata per questa tappa.",
    "error_load": "Errore nel caricamento delle gare.",
    "loading": "Caricamento...",
    "title": "Pick",
    "no_races_title": "Nessuna gara disponibile",
    "no_races_sub": "Non ci sono gare in programma al momento. Torna presto!",
    "banned_title": "Ritiro dalla corsa",
    "banned_stages_one": "Hai saltato 1 tappa",
    "banned_stages_many": "Hai saltato {{count}} tappe",
    "banned_stages_other": "Hai saltato {{count}} tappe",
    "banned_detail": "Puoi seguire i risultati e le pick degli altri, ma non puoi partecipare a questa edizione.",
    "banned_message": "Ci vediamo alla prossima!",
    "stage_finished": "Tappa conclusa. Ecco le pick effettuate.",
    "live_alert": "Gara in corso — formazioni schierate",
    "startlist_btn": "Start list",
    "startlist_title": "Start list",
    "startlist_search": "Cerca dorsale o nome",
    "startlist_dnf": "Ritirato",
    "startlist_empty": "Start list non ancora disponibile",
    "tab_insert": "Inserimento",
    "tab_summary": "Riepilogo",
    "start_list_title": "Start list non ancora pronta",
    "start_list_sub": "La lista dei partecipanti verrà pubblicata a breve. Ricontrolla più tardi.",
    "need_more_one": "Seleziona ancora {{count}} corridore.",
    "need_more_many": "Seleziona ancora {{count}} corridori.",
    "need_more_other": "Seleziona ancora {{count}} corridori.",
    "error_save": "Errore durante il salvataggio.",
    "loading_riders": "Caricamento corridori...",
    "draft_restored": "Bozza ripristinata",
    "draft_count_one": "1 corridore salvato localmente",
    "draft_count_many": "{{count}} corridori salvati localmente",
    "draft_count_other": "{{count}} corridori salvati localmente",
    "draft_cancel": "Annulla",
    "select_n_one": "Seleziona {{count}} corridore",
    "select_n_many": "Seleziona {{count}} corridori",
    "select_n_other": "Seleziona {{count}} corridori",
    "add_rider": "+ Aggiungi corridore ({{current}}/{{limit}})",
    "edit_selection": "Modifica selezione",
    "apply_all": "Applica la scelta a tutte le mie leghe",
    "saved_for": "Salvato per: {{leagues}}",
    "flip_used": "Flip — usato",
    "flip_available": "Flip — disponibile",
    "flip_remove": "Rimuovi",
    "flip_abbinato": "{{rider}} abbinato allo slot {{slot}}",
    "flip_confirmed": "Il flip è stato dichiarato per questa tappa. Al calcolo punti verrà scelto il migliore.",
    "flip_slot_label": "Abbina il flip a quale slot?",
    "flip_confirm_btn": "Conferma flip",
    "saving": "Salvataggio...",
    "confirm_pick": "CONFERMA PICK {{current}}/{{limit}}",
    "select_riders": "Seleziona corridori",
    "search_rider": "Cerca corridore...",
    "no_rider_found": "Nessun corridore trovato",
    "compare_users": "Confronta utenti",
    "confirm": "Conferma",
    "no_pick_found": "Nessuna pick trovata.",
    "toast_multi_one": "Pick salvate su 1 lega",
    "toast_multi_many": "Pick salvate su {{count}} leghe",
    "toast_multi_other": "Pick salvate su {{count}} leghe",
    "toast_single": "Pick salvate!",
    "compare_with": "Confronta con {{names}}",
    "compare_default": "Confronta con altri utenti (max {{max}})",
    "tap_to_change": "• tap per cambiare",
    "you": "(TU)",
    "matrix_hint": "Tocca un corridore per vedere chi l'ha scelto",
    "user_col": "Utente",
    "scout_title": "Scouting Report",
    "scout_top_rider": "Corridore più scelto",
    "scout_distribution": "Distribuzione per slot",
    "scout_variety": "Varietà della lega",
    "scout_distinct": "Corridori distinti scelti",
    "scout_identical": "Cinquine identiche",
    "scout_no_picks": "Fai le tue pick per vedere quanti hanno la tua stessa formazione",
    "loading_lineups": "Caricamento formazioni...",
    "collapse_all": "CHIUDI TUTTO",
    "expand_all": "ESPANDI TUTTO",
    "no_races": "Non ci sono gare disponibili al momento.",
    "add_rider_one": "+ Aggiungi corridore ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} è già stato schierato in una tappa precedente!",
    "draft_count": "Hai {{count}} corridore/i salvati localmente",
    "toast_multi": "Pick salvate su {{count}} leghe",
    "scout_chosen_by": "Scelto da: {{names}}",
    "scout_chosen_by_others": "Scelto da: {{names}} e altri {{count}}",
    "scout_sharing": "Condivisione...",
    "scout_share_btn": "Condividi Scouting Report",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Scelta più coraggiosa",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} giocatori",
    "draft_unsaved_banner": "Pick non confermata — premi Conferma per salvarla",
    "draft_unsaved_title": "Pick non confermata",
    "draft_unsaved_body": "Hai una selezione non salvata. Vuoi confermare la pick prima di uscire?",
    "draft_exit": "Esci senza salvare",
    "draft_confirm_now": "Resta e conferma",
    "share_all": "Tutti",
    "current_league": "Lega attuale",
    "duplicate_rider_reason": "Già usato: {{name}}",
    "flip_saved": "Flip salvato!",
    "flip_deleted": "Flip rimosso.",
    "flip_add_rider": "+ Aggiungi corridore flip (opzionale)",
    "riders_count_one": "1 corridore",
    "riders_count_many": "{{count}} corridori",
    "riders_count_other": "{{count}} corridori",
    "riders_selected_one": "1 selezionato",
    "riders_selected_many": "{{count}} selezionati",
    "riders_selected_other": "{{count}} selezionati",
    "search_user": "Cerca utente...",
    "tab_per_tappa": "Per tappa",
    "tab_matrice": "Presenza corridori",
    "matrix_select_riders": "Scegli corridori da tracciare (max 5)",
    "no_picks_riepilogo": "Nessuna pick trovata",
    "no_picks_riepilogo_sub": "Non hai ancora effettuato pick in questa gara.",
    "scout_avg_pct": "~{{pct}}% medio",
    "scout_no_identical": "Nessun altro ha la tua stessa formazione",
    "scout_identical_count_one": "1 giocatore ha la tua stessa formazione",
    "scout_identical_count_many": "{{count}} giocatori hanno la tua stessa formazione",
    "scout_identical_count_other": "{{count}} giocatori hanno la tua stessa formazione",
    "scout_share_dialog": "Scouting Report — {{name}}",
    "share_hidden": "+ ALTRI {{count}} GIOCATORI · APRI L'APP",
    "no_picks_tabella": "Nessuna formazione inviata",
    "no_picks_tabella_sub": "Le pick degli altri giocatori appariranno qui.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "PICK",
    "race_tag_live": "LIVE",
    "race_tag_done": "CONCLUSA",
    "race_switcher_label": "Gare",
    "race_history": "Storico gare",
    "race_group_next": "Prossime",
    "race_group_past": "Passate",
    "close": "Chiudi",
    "prev_stage": "Tappa precedente",
    "next_stage": "Tappa successiva",
    "stage_list_title": "Tappe",
    "matrix_chosen_by": "{{name}} · scelto da {{count}} su {{total}}",
    "matrix_clear": "Annulla selezione",
    "matrix_chosen_by_a11y": "scelto da {{count}} giocatori su {{total}}",
    "matrix_open_player": "Apri la cinquina di {{name}}",
    "sheet_chosen_by": "{{count}} su {{total}}",
    "sheet_shared": "In comune con te",
    "sheet_unique": "Scelta unica",
    "share_label": "LE CINQUINE",
    "share_most_picked": "PIÙ SCELTO",
    "share_unique_picks": "SCELTE UNICHE",
    "share_unique_sub": "corridori scelti da uno solo",
    "scout2_title": "Scout",
    "scout2_originality": "LA TUA ORIGINALITÀ",
    "scout2_twin": "IL TUO GEMELLO",
    "scout2_identical": "CINQUINE IDENTICHE",
    "scout2_identical_sub": "giocatori con la stessa cinquina",
    "scout2_bold": "Coraggioso",
    "scout2_balanced": "Equilibrato",
    "scout2_aligned": "Allineato",
    "scout2_in_common": "{{count}} su {{total}} in comune",
    "scout2_none": "Nessuno",
    "scout2_popularity": "Popolarità dei corridori",
    "scout2_tap_hint": "Tocca un corridore per evidenziarlo nella tabella",
    "scout2_your_picks": "Le tue scelte",
    "scout2_also_by": "Scelto anche da {{names}}",
    "scout2_only_you": "Solo tu",
    "scout2_outsiders": "Outsider",
    "finished_banner": "Gara conclusa · sei {{pos}}° con {{pts}} pt",
    "finished_banner_nopos": "Gara conclusa",
    "finished_cta": "Classifica",
    "scout2_like_you": "Chi ha giocato come te",
    "scout2_twins_card": "I TUOI GEMELLI",
    "scout2_same_as_you": "{{count}} con la tua stessa cinquina",
    "scout2_same_picks": "Stessa cinquina",
    "scout2_group_count": "{{count}} giocatori",
    "scout2_no_common": "Nessun corridore in comune con",
    "scout2_other_identical": "Altre cinquine identiche",
    "result_title": "Com'è andata",
    "result_total": "Hai totalizzato {{pts}} pt",
    "result_pick_line": "previsto {{slot}}° · arrivato {{rank}}°",
    "result_dnf": "non classificato",
    "result_best": "Il tuo migliore",
    "result_worst": "Ti è costato di più",
    "result_malus": "Vincitore non scelto",
    "result_bonus_top10": "Tutti in top 10",
    "result_bonus_top15": "Tutti in top 15",
    "result_winner": "Il vincitore",
    "result_winner_owners": "scelto da {{count}} su {{total}}",
    "result_nobody": "Nessuno lo aveva",
    "result_difference": "Ha fatto la differenza",
    "result_difference_sub": "chi lo aveva ha fatto in media {{delta}} pt rispetto agli altri",
    "result_flop": "Ha affondato",
    "result_flop_sub": "chi lo aveva ha fatto in media {{delta}} pt rispetto agli altri",
    "rules_title": "Regole in breve",
    "rules_1": "Un corridore per ogni tappa, tre nelle cronometro.",
    "rules_2": "Un corridore non si può usare due volte nello stesso giro.",
    "rules_3": "Se salti anche una sola tappa sei ritirato dal giro: puoi seguire, ma non giocare.",
    "rules_flip": "Flip: una sola volta nel giro, indichi un corridore di riserva; conta al posto del titolare solo se arriva meglio.",
    "profile_flat": "Pianura",
    "profile_hilly": "Collinare",
    "profile_mountain": "Montagna",
    "profile_itt": "Cronometro",
    "profile_ttt": "Cronosquadre",
    "view_by_rider": "Per corridore",
    "view_by_player": "Per giocatore",
    "tour_summary": "{{riders}} corridori scelti da {{players}} giocatori",
    "your_pick": "La tua scelta",
    "tour_your_result": "Il tuo risultato",
    "tour_stage_winner": "Vincitore di tappa",
    "stage_finished_banner": "Tappa conclusa · sei {{pos}}° di tappa ({{gap}})",
    "share_label_stage": "LE SCELTE DELLA TAPPA",
    "share_distinct_riders": "CORRIDORI DIVERSI",
    "scout_t_position": "SEI IN",
    "scout_t_break": "FUGA",
    "scout_t_small": "GRUPPETTO",
    "scout_t_group": "GRUPPO",
    "scout_t_with": "con {{count}} giocatori",
    "scout_t_alone": "solo tu",
    "scout_t_leader": "IL LEADER HA SCELTO",
    "scout_t_jerseys": "Le maglie: cosa hanno scelto",
    "scout_t_breakaway": "In fuga",
    "closes_at": "Chiude {{when}}",
    "closes_in": "Chiude tra {{time}}",
    "profile_title": "Profilo altimetrico",
    "profile_climbs": "Salite",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Profilo altimetrico: {{km}} km, quota massima {{max}} m, {{n}} salite principali",
    "profile_sprint": "S = sprint intermedio",
    "profile_tap_climb": "Tocca un GPM per il dettaglio della salita",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Base",
    "climb_summit": "Cima",
    "climb_avg": "Pendenza media",
    "climb_length": "Lunghezza",
    "profile_bonus": "B = traguardo bonus"
  },
  "join": {
    "back_home": "Torna alla home",
    "welcome": "Benvenuto nella lega!",
    "already_member": "Sei già membro di questa lega.",
    "error": "Impossibile entrare nella lega.",
    "joining": "Accesso alla lega...",
    "success": "Accesso effettuato!"
  },
  "leaderboard": {
    "stage_cancelled": "Tappa {{n}} annullata: non conta per la classifica",
    "loading": "Caricamento...",
    "no_result_title": "Nessun risultato",
    "no_result_sub": "I risultati di questa gara non sono ancora disponibili.",
    "gc_rank": "Classifica Generale",
    "team_no_data": "Nessun dato team per questa tappa.",
    "team_title": "CLASSIFICA TEAM",
    "stage": "Tappa {{n}}",
    "general": "Generale",
    "stage_rank": "Classifica Tappa {{n}}",
    "no_data_title": "Dati non disponibili",
    "no_data_sub": "La classifica per questa tappa non è ancora stata calcolata.",
    "one_day_race": "One Day Race",
    "title": "Classifica",
    "no_data": "Nessun dato disponibile.",
    "share": "Condividi",
    "jersey_tempo": "Tempo",
    "jersey_punti": "Punti",
    "jersey_gpm": "GPM",
    "tab_individual": "Individuale",
    "tab_team": "Team",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "IN CORSO",
    "race_tag_done": "CONCLUSA",
    "race_tag_soon": "IN ARRIVO",
    "leader_label": "In maglia",
    "lead_over_second": "{{gap}} sul 2°",
    "winner": "Vincitore",
    "sheet_total": "Totale",
    "tie": "ex aequo",
    "top10_count": "{{count}} nei primi 10",
    "has_winner": "Ha il vincitore",
    "my_rank": "La tua posizione",
    "counts_for_team": "Conta per il team",
    "not_counting": "Non conta",
    "share_label": "CLASSIFICA",
    "gap_above": "{{gap}} dal {{pos}}°",
    "gap_below": "{{gap}} sul {{pos}}°",
    "trend_up": "Salito di {{n}} posizioni",
    "trend_down": "Sceso di {{n}} posizioni",
    "trend_same": "Posizione invariata",
    "sheet_by_stage": "Tappa per tappa"
  },
  "leagues": {
    "albo": "Albo d'oro",
    "no_podio": "non ha ancora ottenuto podi.",
    "victories": "Vittorie",
    "second": "2° posto",
    "third": "3° posto",
    "races_count_one": "1 gara",
    "races_count_many": "{{count}} gare",
    "races_count_other": "{{count}} gare",
    "player_a": "-- Giocatore A --",
    "player_b": "-- Giocatore B --",
    "draws_one": "1 pareggio",
    "draws_many": "{{count}} pareggi",
    "draws_other": "{{count}} pareggi",
    "on_races_one": "su 1 gara",
    "on_races_many": "su {{count}} gare",
    "on_races_other": "su {{count}} gare",
    "no_common": "Nessuna gara in comune con risultati.",
    "settings": "IMPOSTAZIONI",
    "your_position": "La tua posizione",
    "stagionale": "Classifica Stagionale",
    "hide": "NASCONDI",
    "show_all_one": "MOSTRA TUTTI (1 altro)",
    "show_all_many": "MOSTRA TUTTI ({{count}} altri)",
    "show_all_other": "MOSTRA TUTTI ({{count}} altri)",
    "no_data": "Nessun dato disponibile ancora.",
    "head2head": "Head to Head",
    "races_count": "{{count}} gare",
    "draws": "{{count}} pari",
    "on_races": "su {{count}} gare",
    "show_all": "MOSTRA TUTTI ({{count}} altri)",
    "badge_empty_1": "Nessun badge ancora — la gloria ti aspetta! 🚴",
    "badge_empty_2": "Zero achievement per ora, ma ogni gara è un'occasione. 💪",
    "badge_empty_3": "Ancora nessun badge — i grandi campioni partono da zero. 🏅",
    "badge_empty_4": "Il primo badge è sempre il più difficile. Ci siamo quasi! ⚡",
    "gap_to_podium": "{{gap}} pt dal podio",
    "gap_to_prev": "{{gap}} pt dal {{pos}}°",
    "lead_over_next": "+{{gap}} pt sul {{pos}}°",
    "invite_title": "Siete in pochi?",
    "invite_body": "Invita i tuoi amici per giocare insieme in questa lega.",
    "invite_cta": "Invita amici",
    "pick_member": "Scegli un giocatore",
    "position_a11y": "Posizione {{pos}}",
    "load_error": "Impossibile caricare la lega.",
    "tab_standings": "Classifica",
    "tab_stats": "Statistiche",
    "tab_rivalry": "Sfide"
  },
  "league": {
    "member_count_one": "1 utente in questa lega",
    "member_count_many": "{{count}} utenti in questa lega",
    "member_count_other": "{{count}} utenti in questa lega",
    "index_join": "Unisciti",
    "index_create": "Crea lega",
    "manage_title": "Gestione {{name}}",
    "err_name": "Inserisci un nome",
    "err_password": "Inserisci una password",
    "err_creation": "Errore nella creazione",
    "create_title": "Crea nuova lega",
    "create": "Crea lega",
    "privacy": "Privacy",
    "public": "Pubblica",
    "private": "Privata",
    "err_join": "Errore o sei già iscritto",
    "join_title": "Unisciti a una lega",
    "search_placeholder": "Cerca per nome...",
    "search": "Cerca",
    "no_leagues_found": "Nessuna lega trovata",
    "join_btn": "Entra",
    "password_insert": "Inserisci la password:",
    "calendar_section": "Calendario",
    "calendar_desc_admin": "Gestisci le corse della lega",
    "calendar_desc_user": "Corse in calendario",
    "manage": "Gestisci",
    "view": "Visualizza",
    "calendar_title": "Calendario lega",
    "calendar_save_one": "Salva calendario (1 gara)",
    "calendar_save_many": "Salva calendario ({{count}} gare)",
    "calendar_save_other": "Salva calendario ({{count}} gare)",
    "races_selected_one": "1 gara selezionata",
    "races_selected_many": "{{count}} gare selezionate",
    "races_selected_other": "{{count}} gare selezionate",
    "deselect_all": "Deseleziona tutte",
    "select_all": "Seleziona tutte",
    "loading": "Caricamento...",
    "settings_section": "Impostazioni lega",
    "settings_name": "Nome della lega",
    "settings_save": "Salva",
    "settings_autopick": "Autopick",
    "settings_autopick_desc": "Se un utente non fa la pick, il sistema sceglie il miglior ciclista disponibile dalla tappa precedente.",
    "settings_team_race": "Corsa a squadre",
    "settings_team_race_desc": "Abilita la modalità team per questa lega.",
    "settings_team_size": "Max componenti per team",
    "settings_scoring": "Calcolo punteggio",
    "settings_scoring_best2": "Migliori 2 — somma dei primi due",
    "settings_scoring_avg": "Media di tutti i membri",
    "settings_flip": "Flip",
    "settings_flip_desc": "Ogni utente può indicare un corridore jolly per una tappa a scelta. Al calcolo punti viene scelto automaticamente il migliore tra il titolare e il flip. Usabile una sola volta per gara.",
    "invite_section": "Link di invito",
    "invite_loading": "Caricamento...",
    "invite_copied": "Copiato!",
    "invite_copy": "Copia",
    "invite_share_btn": "Condividi",
    "members_section": "Membri",
    "members_title_admin": "Gestione membri",
    "members_title_user": "Membri della lega",
    "leaving": "Uscita...",
    "leave": "Lascia questa lega",
    "admin_badge": "Admin",
    "remove": "Rimuovi",
    "pick_admin_title": "Correzione Pick",
    "pick_admin_desc": "Modifica le pick degli utenti",
    "pick_admin_open": "Apri",
    "pick_admin_save": "Salva Pick",
    "pick_admin_none": "— nessuno —",
    "pick_admin_search": "Cerca corridore o dorsale",
    "pick_admin_retired": "ritirato",
    "pick_admin_saved2": "{{set}} pick impostate, {{removed}} rimosse",
    "pick_admin_nochange": "Nessuna modifica da salvare",
    "pick_admin_undo": "Annulla l'ultima correzione",
    "pick_admin_undone": "Correzione annullata",
    "pick_admin_future": "Tolte anche {{n}} pick di tappe future con lo stesso corridore",
    "pick_admin_notify": "Avvisa i giocatori",
    "pick_admin_no_calendar": "Questa gara non è nel calendario della lega: non si può salvare",
    "stats_section": "Statistiche",
    "stats_participation": "Partecipazione per tappa",
    "stats_title": "Statistiche partecipazione",
    "stats_no_data": "Nessun dato disponibile.",
    "stats_error": "Impossibile caricare le statistiche. Riprova.",
    "team_loading": "Caricamento team...",
    "team_section": "Team",
    "team_cancel": "Annulla",
    "team_create_btn": "+ Crea team",
    "team_locked": "Corsa in corso — modifiche team disabilitate",
    "team_create": "Crea team",
    "team_members_count_one": "1/{{max}} membro",
    "team_members_count_many": "{{count}}/{{max}} membri",
    "team_members_count_other": "{{count}}/{{max}} membri",
    "team_invite_btn": "+ Invita",
    "team_leave": "Esci",
    "team_save": "Salva",
    "team_pwd_hint": "Lascia vuoto per rendere pubblico",
    "team_pending": "In attesa di risposta",
    "team_invite_cancel": "Annulla",
    "team_invite_section": "Invita un membro",
    "team_no_invitable": "Nessun membro disponibile da invitare.",
    "team_invite_action": "Invita",
    "team_private_label": "\"{{name}}\" è privato:",
    "team_join_action": "Entra",
    "team_empty": "Nessun team ancora — sii il primo a crearne uno!",
    "team_mine": "IL TUO",
    "team_join": "Unisciti",
    "team_full": "Completo",
    "team_members": "Membri",
    "join": "Unisciti",
    "calendar_save": "Salva calendario ({{count}} gare)",
    "invite_share": "Condividi",
    "races_selected": "{{count}} gare selezionate",
    "invite_desc": "Condividi questo link — chi clicca entra direttamente nella lega.",
    "invite_desc_pwd": "Condividi questo link — chi clicca entra direttamente nella lega con la password già inclusa.",
    "member_count": "{{count}} utenti in questa lega",
    "team_members_count": "{{count}}/{{max}} membri",
    "create_name_placeholder": "Es: Gli Amici del Pedale",
    "create_password_placeholder": "Password d'accesso",
    "calendar_saved": "Calendario salvato!",
    "err_name_empty": "Il nome non può essere vuoto",
    "settings_saved": "Impostazioni salvate!",
    "pwd_public_placeholder": "Lascia vuoto per lega pubblica",
    "invite_share_title": "Unisciti a {{name}} su Virtua Cycling",
    "invite_share_message": "Entra nella lega \"{{name}}\" su Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Rigenerare il link? Tutti i link precedenti smetteranno di funzionare.",
    "invite_regenerating": "Rigenerazione...",
    "invite_regen_btn": "Rigenera link (revoca quelli precedenti)",
    "confirm_remove": "Rimuovere {{name}} dalla lega?",
    "member_removed": "{{name}} rimosso",
    "confirm_demote": "Vuoi rimuovere i privilegi admin a {{name}}?",
    "confirm_promote": "Vuoi promuovere admin {{name}}?",
    "demote_admin": "Rimuovi Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} pick salvati!",
    "confirm_team_leave": "Uscire dal team?",
    "confirm_kick": "Rimuovere {{name}} dal team?",
    "team_invite_sent": "Invito inviato!",
    "team_pwd_saved": "Password aggiornata!",
    "team_name_placeholder": "Nome del team...",
    "team_rename_placeholder": "Nuovo nome...",
    "team_newpwd_placeholder": "Nuova password..."
  },
  "profile": {
    "nick_title": "Nickname",
    "theme_title": "Personalizzazione Tema",
    "theme_dark": "Scuro",
    "theme_light": "Chiaro",
    "lang": "Lingua",
    "save_lang": "Salva lingua",
    "nick_success": "Nickname aggiornato!",
    "nick": "Nickname",
    "nick_placeholder": "Inserisci nickname",
    "update_btn": "Aggiorna",
    "pass": "Password",
    "show_pass": "Mostra password",
    "update_pass": "Aggiorna password",
    "avatars_title": "Avatar",
    "avatars": "Mostra avatar",
    "avatars_sub": "Spegnilo se il telefono è lento: al posto degli avatar vedrai la maglia dei corridori e il nome dei giocatori. Il tuo avatar in Home resta.",
    "notif_title": "Notifiche Push",
    "my_leagues": "Le mie leghe",
    "members_count_one": "1 membro",
    "members_count_many": "{{count}} membri",
    "members_count_other": "{{count}} membri",
    "default_badge": "DEFAULT",
    "set_default": "Imposta default",
    "leave": "Lascia",
    "settings": "Impostazioni Profilo",
    "hi": "Ciao",
    "intro": "qui puoi gestire il tuo account.",
    "admin_panel": "Pannello Admin",
    "theme_sub": "Sincronizzato su tutti i tuoi dispositivi.",
    "lang_title": "Lingua / Language",
    "security_title": "Accesso e Sicurezza",
    "security_success": "Dati aggiornati!",
    "notif_enabled": "Attiva notifiche",
    "notif_enabled_sub": "Abilita o disabilita tutte le notifiche",
    "notif_results": "Risultati gara",
    "notif_results_sub": "Notifica quando vengono pubblicati i risultati",
    "notif_startlist": "Start list",
    "notif_startlist_sub": "Notifica quando è disponibile la start list",
    "notif_reminder": "Reminder pick",
    "notif_reminder_sub": "Ricevi un promemoria prima della chiusura delle pick",
    "notif_reminder_off": "Nessun reminder",
    "notif_reminder_no_pick": "Solo se non ho ancora scelto",
    "notif_reminder_always": "Sempre",
    "notif_saving": "Salvataggio...",
    "notif_saved": "Preferenze salvate!",
    "notif_error": "Errore nel salvataggio",
    "nick_taken": "Nickname già in uso",
    "pass_min_length": "La password deve essere di almeno 6 caratteri",
    "pass_mismatch": "Le password non coincidono",
    "new_pass_placeholder": "Nuova password",
    "league_default_updated": "Lega default aggiornata!",
    "league_leave_confirm": "Sei sicuro di voler lasciare \"{{name}}\"?",
    "league_left": "Lega abbandonata.",
    "confirm_password": "Conferma password",
    "avatar_title": "Il tuo avatar",
    "avatar_jersey": "Maglia",
    "avatar_cap": "Cappellino",
    "avatar_glasses": "Occhiali",
    "avatar_cyclist": "Ciclista",
    "avatar_patch": "Patch maglia",
    "avatar_saved": "Avatar salvato!",
    "avatar_save_btn": "Salva avatar",
    "rules": "Regolamento",
    "report_bug": "Segnala un problema",
    "bug_sent": "Segnalazione inviata, grazie!",
    "bug_placeholder": "Descrivi il problema...",
    "group_identity": "Identità",
    "group_account": "Account",
    "group_contact": "Contattaci",
    "group_danger": "Zona pericolosa",
    "change_pass": "Cambia",
    "cancel": "Annulla",
    "show_more": "Mostra tutte ({{count}} altre)",
    "show_less": "Mostra meno",
    "delete_confirm": "Sei sicuro di voler eliminare il tuo account? Questa azione è irreversibile e tutti i tuoi dati verranno eliminati definitivamente.",
    "delete_desc": "L'eliminazione è permanente e rimuove tutti i tuoi dati, formazioni, leghe e preferenze.",
    "delete_btn": "Elimina il mio account",
    "delete_league_owner": "Hai creato una lega con altri iscritti: eliminandoti sparirebbe per tutti. Contattaci per trasferirla o eliminala prima.",
    "replay_tour": "Rivedi il tour",
    "leave_feedback": "Lascia un feedback",
    "feedback_placeholder": "Un'idea, un suggerimento o un commento: ci fa piacere leggerti...",
    "feedback_sent": "Grazie per il tuo feedback! 🙏",
    "rate_app": "Valuta Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Inserisci un nickname",
    "err_nickname_taken": "Nickname già in uso",
    "register_ok": "Registrazione completata! Controlla la tua email e conferma l'account prima di accedere.",
    "err_email": "Inserisci la tua email",
    "forgot_sent": "Email inviata! Controlla la tua casella.",
    "tagline": "Prendi il tuo posto in ammiraglia.",
    "tab_login": "Accedi",
    "tab_register": "Registrati",
    "forgot_hint": "Inserisci la tua email e ti mandiamo un link per reimpostare la password.",
    "email": "Email",
    "forgot_send": "Invia link",
    "back": "← Torna al login",
    "nickname": "Nickname",
    "password": "Password",
    "btn_login": "ACCEDI",
    "btn_register": "REGISTRATI",
    "forgot_pass": "Password dimenticata?",
    "or": "oppure",
    "google_login": "Accedi con Google",
    "google_register": "Registrati con Google",
    "privacy_text": "Continuando accetti la nostra",
    "privacy_link": "Privacy Policy",
    "loading": "…"
  },
  "news": {
    "title": "NEWS",
    "loading": "Caricamento...",
    "no_news": "Nessuna news disponibile.",
    "pinned": "In evidenza",
    "not_found": "Articolo non trovato.",
    "open_external": "Apri l'articolo su {{source}}",
    "disclaimer": "Titoli e link provengono da fonti esterne: gli articoli appartengono ai rispettivi editori.",
    "tab_unread_one": "{{count}} news nuova",
    "tab_unread_other": "{{count}} news nuove",
    "load_error": "Non siamo riusciti a caricare le news."
  },
  "reset_password": {
    "title": "NUOVA PASSWORD",
    "subtitle": "Scegli una nuova password per il tuo account",
    "show_pass": "Mostra password",
    "loading": "Verifica del link in corso...",
    "success": "Password aggiornata! Verrai reindirizzato..."
  },
  "confirm": {
    "verifying": "Verifica in corso...",
    "error": "Errore durante la conferma.",
    "success": "Email confermata! Verrai reindirizzato...",
    "missing_params": "Parametri mancanti nel link.",
    "missing_params_detail": "Assicurati di aver cliccato il link corretto dalla tua email.",
    "critical_error": "Errore critico di connessione."
  },
  "notifications": {
    "title": "Notifiche",
    "empty": "Nessuna notifica ancora",
    "accept": "Accetta",
    "refuse": "Rifiuta",
    "now": "Adesso",
    "minutes_ago": "{{count}} min fa",
    "hours_ago": "{{count}}h fa"
  },
  "quiz": {
    "card_sub": "10 domande sul Tour de France — quanto ne sai?",
    "loading": "Caricamento domande...",
    "no_questions": "Nessuna domanda disponibile",
    "question_count": "Domanda {{current}} di {{total}}",
    "easy": "Facile",
    "medium": "Medio",
    "hard": "Difficile",
    "correct": "Risposta corretta!",
    "wrong": "Sbagliato. La risposta era: {{answer}}",
    "next": "Prossima",
    "see_result": "Vedi risultato",
    "restart": "Rigioca",
    "result_excellent": "Sei un vero esperto di ciclismo!",
    "result_good": "Ottima conoscenza del Tour de France!",
    "result_average": "Discreta conoscenza. Guarda più corse!",
    "result_poor": "C'è margine di miglioramento — ma è per questo che si pedala!"
  },
  "person": {
    "hint": "Scegli l'aspetto del tuo avatar: lo vedi nella Home.",
    "gender": "Genere",
    "man": "Uomo",
    "woman": "Donna",
    "hair_short": "Corti",
    "hair_curly": "Ricci",
    "hair_wavy": "Mossi",
    "hair_shaved": "Rasato",
    "hair_pixie": "Pixie",
    "hair_bob": "Caschetto",
    "headwear": "Copricapo",
    "wear_none": "Nessuno",
    "wear_cap": "Cappellino",
    "wear_helmet": "Casco",
    "glasses": "Occhiali",
    "glasses_off": "No",
    "glasses_on": "Sì",
    "jersey": "Maglia",
    "jersey_vertical": "Verticale",
    "jersey_horizontal": "Orizzontale",
    "jersey_classic": "Classica",
    "jersey_diagonal": "Diagonale",
    "jersey_dots": "Pois",
    "row_skin": "Pelle",
    "row_hair": "Capelli",
    "row_brow": "Sopracciglia",
    "row_iris": "Occhi",
    "row_wear": "Copricapo",
    "row_visor": "Visiera",
    "row_vents": "Prese d'aria",
    "row_frame": "Montatura occhiali",
    "save": "SALVA",
    "saved": "Avatar salvato",
    "save_error": "Errore nel salvataggio",
    "reset": "Ripristina",
    "reset_done": "Ripristinato",
    "tab_face": "Viso",
    "tab_hair": "Capelli",
    "tab_gear": "Accessori",
    "tab_jersey": "Maglia",
    "row_lens": "Lenti",
    "jersey_body": "Corpo",
    "jersey_sleeves": "Maniche",
    "jersey_band": "Banda",
    "jersey_trim": "Colletto e polsini",
    "view_mine": "Il mio avatar",
    "view_world_champion": "Maglia iridata",
    "world_champion_since": "Campione del mondo in {{league}} dal {{date}}",
    "view_european_champion": "Maglia europea",
    "european_champion_since": "Campione europeo in {{league}} dal {{date}}",
    "view_worldcup_leader": "Maglia Coppa del Mondo",
    "worldcup_leader_since": "Leader della classifica di {{league}} dal {{date}}",
    "kits_show": "Mostra kit squadre (admin)",
    "kits_hide": "Nascondi kit squadre",
    "kits_hint": "Maglie delle squadre importate da PCS: controlla colori e disegno. I kit si correggono nel database.",
    "kits_approx": "approssimato",
    "kits_men": "Uomini",
    "kits_women": "Donne",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tocca una squadra per vedere i corridori",
    "kits_no_riders": "Nessun avatar per questa squadra.",
    "avatar_edit": "Modifica avatar",
    "avatar_cut": "Taglio",
    "avatar_hair": "Capelli",
    "avatar_skin": "Pelle",
    "avatar_beard": "Barba",
    "avatar_beard_none": "Nessuna",
    "avatar_face": "Volto",
    "avatar_face_none": "Di serie",
    "avatar_face_a": "Magro",
    "avatar_face_b": "Robusto",
    "avatar_face_c": "Giovane",
    "avatar_face_d": "Spigoloso",
    "avatar_face_e": "Maturo",
    "avatar_face_f": "Sorridente",
    "avatar_face_g": "Sorriso chiuso",
    "avatar_brow": "Sopracciglia",
    "avatar_brow_0": "Normali",
    "avatar_brow_1": "Sottili",
    "avatar_brow_2": "Folte",
    "avatar_beard_light": "Leggera",
    "avatar_hex": "Altro colore (#RRGGBB)",
    "avatar_save": "Salva",
    "avatar_reset": "Ripristina",
    "avatar_undo": "Annulla ultima modifica",
    "avatar_saved": "Salvato",
    "avatar_bad_hex": "Colore non valido: usa #RRGGBB",
    "avatar_err": "Errore nel salvataggio",
    "avatar_beard_legend": "1 ombra · 2 baffi · 3 corta · 4 piena · 6 baffi+pizzetto · 7 cerchio · 8 accenno",
    "hair_wavy_medium": "Mossi medi",
    "hair_receding": "Stempiato",
    "hair_messy": "Spettinato",
    "hair_buzz": "Cortissimo",
    "hair_curly_short": "Ricci corti",
    "hair_medium": "Medi alle spalle",
    "hair_flip_off": "Lato normale",
    "hair_flip_on": "Specchiati",
    "hair_side_part": "Riga di lato",
    "hair_slicked_back": "All'indietro",
    "hair_forward": "In avanti",
    "hair_high_line": "Attaccatura alta",
    "hair_wavy_short": "Ondulati corti",
    "hair_curly_medium": "Riccio medio",
    "hair_receding_short": "Stempiato corto",
    "beard_stubble_light": "Accenno",
    "hair_long": "Lunghi",
    "hair_ponytail": "Coda",
    "hair_bun": "Chignon",
    "hair_long_wavy": "Ondulati",
    "hair_braid": "Treccia",
    "beard": "Barba",
    "beard_none": "Nessuna",
    "beard_stubble": "Ombra",
    "beard_moustache": "Baffi",
    "beard_short": "Corta",
    "beard_full": "Piena",
    "beard_goatee": "Baffi e pizzetto",
    "beard_circle": "A cerchio",
    "beard_op_normal": "Normale",
    "beard_op_light": "Leggera",
    "fringe": "Frangia",
    "fringe_off": "Senza",
    "fringe_on": "Con frangia"
  },
  "app_update": {
    "title": "Nuova versione pronta",
    "body": "Riavvia l'app per usare le novità.",
    "restart": "Riavvia",
    "later": "Più tardi"
  },
  "avatar": {
    "invite_title": "Ecco il tuo avatar!",
    "invite_body": "Ne abbiamo creato uno per te: personalizzalo come vuoi.",
    "invite_cta": "Personalizza",
    "invite_dismiss": "Chiudi",
    "edit_a11y": "Personalizza il tuo avatar"
  },
  "jersey_celebration": {
    "ok": "Fantastico!"
  },
  "insight": {
    "you": "Con te",
    "form": "Forma",
    "never": "Mai scelto con te: sarebbe la prima volta.",
    "picked": "Volte scelto",
    "avg_rank": "Piazzamento medio",
    "avg_gap": "Distacco medio",
    "best": "Miglior risultato",
    "dnf": "Ritiri con te",
    "last": "Ultima volta",
    "retired": "ritirato",
    "form_avg": "Media ultime 5",
    "season_races": "Gare in stagione",
    "top10": "Primi 10",
    "wins": "Vittorie",
    "dnfs": "Ritiri",
    "cat_1": "Tappe di pianura",
    "cat_2": "Tappe di montagna",
    "cat_3": "Tappe collinari",
    "last5": "Ultimi 5 risultati",
    "no_results": "Ancora nessun risultato in stagione.",
    "open_a11y": "Insight su {{name}}",
    "summary": "{{n}}× con te · media {{rank}}°",
    "summary_never": "Mai scelto con te",
    "open": "Insight"
  },
  "badges": {
    "title": "Badge",
    "album_title": "Bacheca",
    "earned_of": "{{earned}} su {{total}} badge",
    "open_album": "Apri la Bacheca",
    "recent": "Ultimi ottenuti",
    "next_goals": "Traguardi vicini",
    "filter_all": "Tutti",
    "filter_earned": "Ottenuti",
    "filter_todo": "Da ottenere",
    "group_gt": "Grandi Giri",
    "group_monuments": "Monumenti e classiche",
    "group_picks": "Abilità nelle pick",
    "group_consistency": "Costanza",
    "group_league": "Classifica di lega",
    "group_social": "Sociali",
    "group_meta": "Collezione",
    "tier_1": "Bronzo",
    "tier_2": "Argento",
    "tier_3": "Oro",
    "tier_4": "Platino",
    "tier_special": "Traguardo",
    "secret_title": "Badge segreto",
    "secret_hint": "Scoprilo giocando.",
    "earned_on": "Ottenuto il {{date}}",
    "progress": "{{value}} su {{threshold}}",
    "rarity": "Ce l'ha il {{pct}}% della lega ({{n}} su {{m}})",
    "rarity_none": "Nessuno ce l'ha ancora: puoi essere il primo.",
    "seasons": "Stagioni ottenute: {{count}}",
    "complete": "Completato",
    "locked": "Da ottenere",
    "player": "Giocatore",
    "none_me": "Nessun badge ancora: la prossima gara è l'occasione giusta.",
    "none_other": "{{name}} non ha ancora badge.",
    "empty_filter": "Niente da mostrare con questo filtro.",
    "load_error": "Impossibile caricare i badge.",
    "not_enabled": "I badge non sono ancora attivi per questa lega.",
    "fam": {
      "RE_GT": {
        "title": "Re dei Grandi Giri",
        "desc": "Grandi Giri vinti: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Re del Giro",
        "desc": "Vinci la classifica generale del Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "Re del Tour",
        "desc": "Vinci la classifica generale del Tour de France"
      },
      "WIN_VUELTA": {
        "title": "Re della Vuelta",
        "desc": "Vinci la classifica generale della Vuelta"
      },
      "GT_PODI": {
        "title": "Podi nei Grandi Giri",
        "desc": "Podi nei Grandi Giri: {{n}}"
      },
      "GT_DAYS": {
        "title": "Giorni in maglia",
        "desc": "Giorni in maglia di leader della generale: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Maglia rosa",
        "desc": "Diventa leader della generale al Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Maglia gialla",
        "desc": "Diventa leader della generale al Tour de France"
      },
      "FIRST_RED": {
        "title": "Maglia rossa",
        "desc": "Diventa leader della generale alla Vuelta"
      },
      "GT_GREEN": {
        "title": "Re dei velocisti",
        "desc": "Classifiche a punti vinte nei Grandi Giri: {{n}}"
      },
      "GT_POIS": {
        "title": "Re della montagna",
        "desc": "Classifiche della montagna vinte nei Grandi Giri: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Cacciatore di tappe",
        "desc": "Tappe vinte nei Grandi Giri: {{n}}"
      },
      "GT_WIRE": {
        "title": "Dall'inizio alla fine",
        "desc": "Guida la generale dalla prima all'ultima tappa e vinci il Grande Giro"
      },
      "GT_COMEBACK": {
        "title": "Rimonta",
        "desc": "Vinci un Grande Giro stando oltre il 10° posto dopo la prima settimana"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Trionfo totale",
        "desc": "Vinci generale, punti e montagna nello stesso Grande Giro"
      },
      "GT_HEARTBREAK": {
        "title": "La beffa",
        "desc": "Eri leader alla vigilia dell'ultima tappa, ma non hai vinto il Grande Giro"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Vinci Giro, Tour e Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Vinci Giro e Tour nello stesso anno"
      },
      "RE_MONUMENTI": {
        "title": "Re dei Monumenti",
        "desc": "Monumenti vinti: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Vinci la Milano-Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "Il Fiandre",
        "desc": "Vinci il Giro delle Fiandre"
      },
      "WIN_ROUBAIX": {
        "title": "L'Inferno del Nord",
        "desc": "Vinci la Parigi-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Vinci la Liegi-Bastogne-Liegi"
      },
      "WIN_LOMBARDIA": {
        "title": "La classica delle foglie morte",
        "desc": "Vinci il Giro di Lombardia"
      },
      "MONUMENTS_SWEEP": {
        "title": "The Monuments Sweep",
        "desc": "Vinci tutti e 5 i Monumenti"
      },
      "RE_DEL_NORD": {
        "title": "Re del Nord",
        "desc": "Vinci Fiandre e Roubaix nello stesso anno"
      },
      "ARDENNES": {
        "title": "Triplete delle Ardenne",
        "desc": "Vinci Amstel, Freccia Vallone e Liegi nello stesso anno"
      },
      "DUE_MARI": {
        "title": "Corsa dei due mari",
        "desc": "Vinci Parigi-Nizza e Tirreno-Adriatico nello stesso anno"
      },
      "MODALITA_POGACAR": {
        "title": "Modalità Pogačar",
        "desc": "Vinci tutti e 3 i Grandi Giri e tutti e 5 i Monumenti"
      },
      "RE_CLASSICHE": {
        "title": "Re delle Classiche",
        "desc": "Classiche vinte: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Re delle corse a tappe",
        "desc": "Corse a tappe vinte: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Campione del Mondo",
        "desc": "Vinci la prova in linea dei Mondiali"
      },
      "EURO_CHAMP": {
        "title": "Campione Europeo",
        "desc": "Vinci la prova in linea degli Europei"
      },
      "CRONOMAN": {
        "title": "Cronoman",
        "desc": "Vinci una prova a cronometro dei Mondiali o degli Europei"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Unico a scegliere il vincitore: {{n}}"
      },
      "PROFETA": {
        "title": "Profeta",
        "desc": "Scelte vincenti: {{n}}"
      },
      "FIUTO": {
        "title": "Fiuto",
        "desc": "Vincitori scelti da pochi: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Vincitore di gara",
        "desc": "Gare vinte in lega: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Habitué del podio",
        "desc": "Podi di gara in lega: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debutto",
        "desc": "Gioca la tua prima gara"
      },
      "PRESENZE": {
        "title": "Presenze",
        "desc": "Gare giocate: {{n}}"
      },
      "SERIE": {
        "title": "In serie",
        "desc": "Gare consecutive giocate: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Stagione perfetta",
        "desc": "Gioca tutte le gare della stagione"
      },
      "LEADER_STAGIONE": {
        "title": "Al comando",
        "desc": "Gare chiuse al comando della classifica: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Campione di lega",
        "desc": "Chiudi la stagione al primo posto della classifica"
      },
      "PODIO_LEGA": {
        "title": "Podio di lega",
        "desc": "Chiudi la stagione sul podio della classifica"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Chiudi la stagione nei primi 10 della classifica"
      },
      "SCALATORE": {
        "title": "Scalatore",
        "desc": "Posizioni guadagnate in una sola gara: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Ammazzagiganti",
        "desc": "Gare chiuse davanti al leader della classifica: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Badge ottenuti: {{n}}"
      },
      "LEGGENDA": {
        "title": "Leggenda",
        "desc": "Ottieni tutti i badge"
      }
    },
    "celebration_one": "Nuovo badge!",
    "celebration_many": "{{n}} nuovi badge!",
    "celebration_more": "e altri {{n}}",
    "share": "Condividi",
    "share_label": "BADGE OTTENUTO",
    "share_dialog": "Il mio badge: {{name}}",
    "share_text": "Ho ottenuto il badge «{{name}}» su Virtua Cycling! {{site}}",
    "showcase_title": "In evidenza",
    "showcase_hint": "Scegli fino a 3 badge da mettere in mostra. Se non scegli, mostriamo i più rari che hai.",
    "showcase_edit": "Modifica",
    "showcase_auto": "Automatica",
    "showcase_save": "Salva",
    "showcase_count": "{{n}} di 3 scelti",
    "showcase_err": "Non è stato possibile salvare la selezione.",
    "showcase_a11y": "I tuoi badge in evidenza",
    "showcase_none": "Ottieni il tuo primo badge per vederlo qui.",
    "showcase_pick_empty": "Non hai ancora badge da mettere in vetrina.",
    "jerseys_title": "Maglie dei Grandi Giri",
    "jersey_pink": "Maglia rosa",
    "jersey_yellow": "Maglia gialla",
    "jersey_red": "Maglia rossa",
    "days_caption": "Giorni in maglia",
    "section_jerseys": "Maglie",
    "special_title": "Maglie speciali",
    "special_now": "In uso",
    "trophy_sub": "Badge, maglie e albo d'oro"
  },
  "rivalry": {
    "title": "Sfide",
    "intro": "Scegli un avversario. Se accetta, da quella gara in poi vince il punto chi chiude davanti all'altro. Tutta la lega vede come va.",
    "slots": "Sfide lanciate: {{used}} su {{max}}",
    "limit_reached": "Hai lanciato il massimo di sfide. Annulla o chiudi una sfida per lanciarne un'altra.",
    "no_candidates": "Non ci sono altri giocatori da sfidare.",
    "challenge_cta": "Lancia una sfida",
    "pick_title": "Chi vuoi sfidare?",
    "confirm_challenge": "Sfidare {{name}}? Riceverà la richiesta e potrà accettare o rifiutare.",
    "sent": "Richiesta inviata a {{name}}.",
    "accepted": "Hai accettato la sfida con {{name}}.",
    "incoming_title": "Richieste ricevute",
    "incoming_line": "{{name}} ti sfida",
    "accept": "Accetta",
    "decline": "Rifiuta",
    "waiting_title": "In attesa di risposta",
    "waiting_line": "In attesa di {{name}}",
    "cancel": "Annulla",
    "mine_title": "Le tue sfide",
    "league_title": "Nella lega",
    "ended_title": "Sfide concluse: {{count}}",
    "empty": "Nessuna sfida in corso nella lega. Lancia la prima!",
    "vs": "contro",
    "score_a11y": "{{a}} a {{b}}",
    "last_point": "Ultimo punto: {{name}} in {{race}}",
    "no_races": "Nessuna gara ancora",
    "won_by": "Vinta da {{name}}",
    "drawn": "Finita in pareggio",
    "detail_title": "Sfida",
    "results_title": "Gara per gara",
    "no_results": "Ancora nessun punto assegnato.",
    "point_to": "Punto a {{name}}",
    "end_cta": "Chiudi la sfida",
    "end_confirm": "Chiudere la sfida con {{name}}?",
    "rematch": "Rivincita",
    "load_error": "Impossibile caricare le sfide.",
    "err_limit": "Hai già lanciato il massimo di sfide.",
    "err_exists": "Siete già in sfida, o c'è una richiesta in corso.",
    "err_invalid": "Questa richiesta non è più valida.",
    "err_generic": "Non è stato possibile completare l'operazione.",
    "notif_accepted": "Sfida accettata",
    "notif_declined": "Sfida rifiutata"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Competizione"
  },
  "no_league": {
    "title": "Non partecipi a nessuna lega {{comp}}",
    "body": "Puoi unirti a una lega o crearne una nuova dalla sezione Leghe.",
    "body_official": "Puoi entrare nella lega ufficiale quando vuoi, oppure unirti o creare una lega privata dalla sezione Leghe.",
    "join": "Entra in {{name}}",
    "go_leagues": "Vai alle leghe"
  }
}
